import { render } from "./pagemodal.vue?vue&type=template&id=e66a178e"
import script from "./pagemodal.vue?vue&type=script&lang=js"
export * from "./pagemodal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__